import api from './api'; // axios instance с базовым URL

export async function addUser(token, userData) {
  const response = await api.post('/users', userData, {
    headers: { Authorization: `Bearer ${token}` },
  });
  console.log('API Response:', response); 
  return response.data;
}

export async function fetchUsers(token) {
  const response = await api.get('/users/getusers', {
    headers: { Authorization: `Bearer ${token}` },
  });
  console.log('API Response:', response); 
  return response.data;
}